import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

import Header_Company from '../../Components/Header_Company';
import CurrentDayRecord from '../../Components/CompanyDetails/CurrentDayRecord';
import AllRecord from '../../Components/CompanyDetails/AllRecord';

const Company_Dashboard = () => {
  const [activeTab, setActiveTab] = useState('currentDay');  // Default tab

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("user");
    if (!storedUserData) {
      Swal.fire("Error", "No user data found in sessionStorage.", "error");
    }
  }, []);

  return (
    <div className="container-fluid">
      <Header_Company />

      {/* Tabs */}
      <ul className="nav nav-tabs" id="myTab" role="tablist">
        <li className="nav-item" role="presentation">
          <a
            className={`nav-link ${activeTab === 'currentDay' ? 'active' : ''}`}
            id="currentDay-tab"
            data-bs-toggle="tab"
            href="#currentDay"
            role="tab"
            aria-controls="currentDay"
            aria-selected={activeTab === 'currentDay'}
            onClick={() => setActiveTab('currentDay')}
          >
            Current Day Record
          </a>
        </li>
        <li className="nav-item" role="presentation">
          <a
            className={`nav-link ${activeTab === 'allRecord' ? 'active' : ''}`}
            id="allRecord-tab"
            data-bs-toggle="tab"
            href="#allRecord"
            role="tab"
            aria-controls="allRecord"
            aria-selected={activeTab === 'allRecord'}
            onClick={() => setActiveTab('allRecord')}
          >
            All Record
          </a>
        </li>
      </ul>

      {/* Tab Content */}
      <div className="tab-content mt-4" id="myTabContent">
        <div
          className={`tab-pane fade ${activeTab === 'currentDay' ? 'show active' : ''}`}
          id="currentDay"
          role="tabpanel"
          aria-labelledby="currentDay-tab"
        >
          <CurrentDayRecord />
        </div>

        <div
          className={`tab-pane fade ${activeTab === 'allRecord' ? 'show active' : ''}`}
          id="allRecord"
          role="tabpanel"
          aria-labelledby="allRecord-tab"
        >
          <AllRecord />
        </div>
      </div>
    </div>
  );
};

export default Company_Dashboard;
